import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const CustomerInteractionDetails = () => {
  const { interactionId: id } = useParams();
  const decodedId = id ? atob(id) : id;
  const interactionId = decodedId ? decodedId.replace(/\D/g, '') : '';
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);
  const [customer, setCustomer] = useState(null);
  const [handler, setHandler] = useState(null);
  const [showDelete, setShowDelete] = useState(false);

  const url = interactionId ? `${API_DOMAIN}${API_ROUTES.customerInteraction}${interactionId}/` : null;
  const { data: interaction, loading } = useDetailFetch(url);

  useEffect(() => {
    if (!interaction) return;

    const fetchRelatedData = async () => {
      try {
        if (interaction.customer) {
          const customerResponse = await axios.get(`${API_DOMAIN}${API_ROUTES.customer}${interaction.customer}/`);
          setCustomer(customerResponse.data);
        }

        if (interaction.handler) {
          const handlerResponse = await axios.get(`${API_DOMAIN}${API_ROUTES.users}${interaction.handler}/`);
          setHandler(handlerResponse.data);
        }
      } catch (error) {
        console.error('Error fetching related details:', error);
      }
    };

    fetchRelatedData();
  }, [interaction]);

  const columns = useMemo(() => {
    if (!interaction) return [];
    const excludedColumns = ['id', 'updated_at', 'created_at'];
    return Object.keys(interaction)
      .filter(column => !excludedColumns.includes(column))
      .map((column) => ({
        label: column.charAt(0).toUpperCase() + column.slice(1),
        field: column,
      }));
  }, [interaction]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.customerInteraction}${interactionId}/`);
      showToast('Interaction deleted successfully', 'success');
      navigate('/customer/interactions/list');
    } catch (error) {
      console.error('Error deleting interaction:', error);
      showToast('Error deleting interaction', 'error');
    }
  };

  const contactDetails = {
    date: interaction?.date,
    interactionType: interaction?.interaction_type,
    outcome: interaction?.outcome,
    customer: customer ? customer.name : 'Unknown',
    handler: handler ? handler.username : 'Unknown',
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={contactDetails}
        columns={columns}
        entityName="Interaction"
        listPath="/customer/interactions/list"
        editPath={`/customer/interaction/input/${btoa(interactionId)}`}
        onDelete={() => setShowDelete(true)}
        loading={loading}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Interaction"
        message="Are you sure you want to delete this interaction?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default CustomerInteractionDetails;
